import { mapState, mapGetters, mapActions } from "vuex";

export const localize = {
  data: function () {
    return {
      gCollectingItem: -1
    }
  },

  methods: {
    ...mapActions([
      "initAUID"
    ]),
    localize(str) {
      if (!this.localizedUIReady) {
        return null;
      }
      let tag = str.toLowerCase().replace(/(\s|-)/g, "_");
      let obj = _.find(this.localizedUI, { tag });
      if (obj) {
        return obj.title;
      }
      return str;
      // return null;
    },

    ///////////////////////////////////////////////////////////////////////////
    //// specific localization for mini-sites
    ///////////////////////////////////////////////////////////////////////////
    ms_localize(str) 
    {      
      let dicArray = this.minisite_dic.dictionary;
      let tag = str.toLowerCase().replace(/(\s|-)/g, "_");
      tag = tag.substring(1);//remove the init @
      let obj1 = _.find(dicArray, { 'tag': tag });
      if(obj1)
      {
        var lang = this.locale.ln;
        let trans = obj1[lang.toLowerCase()];
        if(trans){
          return trans;
        }else{
          return obj1['en'];//take default if translation not exist
        }        
      }

      //let obj = _.find(dicArray, { tag });
      //if (obj) {
        //return obj.en;///<<<<<<<replace the lang by this.siteLang
      //}

      return str;
      // return null;
    },
    


    //Manage products collections
    createCollection(collection_name)
    {        
        alert("collection_name="+collection_name);//check if name exists
    },
    addProductToCollection(pro_id)
    {
        this.initAUID();//INIT THE AUID BEFOR CALLING THE API
        alert("adding item:"+pro_id +" auid:"+this.auid);

    },
    getProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    },
    shareProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    }

  },
  computed: {
    ...mapState(["minisite_dic","localizedUI", "localizedUIReady","auid","locale"])
  }
};
